import getState from "../MainHelper";

// Confirm to user the saving of build targets.
export const needToConfirmSavingBuildTargets = () => {
    const {
        buildTargets: { editTarget },
        reports: {
            reportIsLoading, generalMarketCategoriesData, audienceSpecificCategoriesData, categoryDeepDiveData
        }
    } = getState();;

    let confirm = false;
    let confirmText = "";
    if (editTarget) {
        if (reportIsLoading) {
            confirm = true;
            confirmText = "Generating Reports. Are you sure you want to continue?";
        } else if (generalMarketCategoriesData.length || audienceSpecificCategoriesData.length || categoryDeepDiveData.length) {
            confirm = true;
            confirmText = "The existing report will be removed. Are you sure you want to continue?";
        }
    }
    return {
        confirm,
        confirmText
    };
};

export const needToConfirmTheResultWillRemoved = (changeReport) => {
    const {
        reports: {
            reportIsLoading, generalMarketCategoriesData, audienceSpecificCategoriesData, categoryDeepDiveData
        }
    } = getState();;

    let confirm = false;
    let confirmText = "";
    if (reportIsLoading) {
        confirm = true;
        confirmText = "Generating Reports. Are you sure you want to continue?";
    } else if (generalMarketCategoriesData.length || audienceSpecificCategoriesData.length || categoryDeepDiveData.length) {
        confirm = true;
        if (changeReport) {
            confirmText = "Are you sure you want to continue?";
        } else {
            confirmText = "The existing report will be removed. Are you sure you want to continue?";
        }
    }
    return {
        confirm,
        confirmText
    };
};

export const needToConfirmSavingQuickReports = (currentQuickReport) => {
    const {
        reports: {
            selectedQuickReport, reportIsLoading, generalMarketCategoriesData, audienceSpecificCategoriesData, categoryDeepDiveData
        }
    } = getState();;

    let confirm = false;
    let confirmText = "";
    let withAppend = false;
    if (selectedQuickReport) {
        const quickReportChecking = (JSON.stringify(selectedQuickReport) !== JSON.stringify(currentQuickReport));
        if (reportIsLoading && quickReportChecking) {
            confirm = true;
            confirmText = "Generating Reports. Are you sure you want to continue?";
        } else if (quickReportChecking
            && (generalMarketCategoriesData.length || audienceSpecificCategoriesData.length || categoryDeepDiveData.length)) {
            withAppend = true;
            confirm = true;
            confirmText = "A dashboard report is currently on display. Would you like to Append the new results or Replace the existing dashboard?";
        }
    }
    return {
        confirm,
        confirmText,
        withAppend
    };
};

export const needToConfirmChangesInBuildTargets = (textList) => {
    const {
        marketExplorer: {
            configuration: {
                toEditData
            }
        }, reportBuilder: { mode }
    } = getState();;
    if (!toEditData.data) return false;
    if (mode === "select") return false;
    return JSON.stringify(toEditData.data.targets) !== JSON.stringify(textList);
};
